import trackQuestionViewedEvent from 'packages/signup/analytics/trackQuestionViewed';
import type { SurveyQuestionsKeys } from 'packages/signup/components/SurveyQuestions';

export default function trackViewedPages(arraySurveyQuestionsKeys: any) {
  arraySurveyQuestionsKeys.forEach((questionKey: SurveyQuestionsKeys) => {
    trackQuestionViewedEvent(questionKey);
  });
}
